// router/index.js
import {
	createRouter,
	createWebHashHistory,
	createWebHistory
} from 'vue-router'

const routes = [
	{
		path: '/',
		component: () => import('@/views/Home.vue'),
		meta: {
			title: '春之语',
			requiresAuth: true,
			showTabBar: true
		}
	},
	{
		path: '/service',
		component: () => import('@/views/Service.vue'),
		meta: {
			title: '服务套餐',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/tech',
		component: () => import('@/views/Tech.vue'),
		meta: {
			title: '健康师',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/chat',
		component: () => import('@/views/chat/List.vue'),
		meta: {
			title: '聊天会话',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/chat-message',
		component: () => import('@/views/chat/Message.vue'),
		meta: {
			title: '聊天消息',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		name: 'TechDetail',
		path: '/tech-detail',
		component: () => import('@/views/tech/TechDetail.vue'),
		meta: {
			title: '健康师详情',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		name: 'TechPortfolio',
		path: '/tech-portfolio',
		component: () => import('@/views/tech/TechPortfolio.vue'),
		meta: {
			title: '个人作品主页',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		name: 'TechReview',
		path: '/tech-review',
		component: () => import('@/views/tech/Review.vue'),
		meta: {
			title: '评价健康师',
			requiresAuth: true,
			showTabBar: false
		}
	},
	{
		name: 'TechReviews',
		path: '/tech-reviews',
		component: () => import('@/views/tech/Reviews.vue'),
		meta: {
			title: '健康师评价',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/message-center',
		component: () => import('@/views/Message/Center.vue'),
		meta: {
			title: '消息中心',
			requiresAuth: true,
			showTabBar: true
		}
	},
	{
		path: '/message-list',
		component: () => import('@/views/Message/List.vue'),
		meta: {
			title: '消息列表',
			requiresAuth: true,
			showTabBar: false
		}
	},
	{
		path: '/portfolio',
		component: () => import('@/views/Portfolio.vue'),
		meta: {
			title: '动态',
			requiresAuth: false,
			showTabBar: true
		}
	},
	{
		path: '/portfolio/detail',
		component: () => import('@/views/portfolio/PortfolioDetail.vue'),
		meta: {
			title: '动态详情',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/portfolio/topic',
		component: () => import('@/views/portfolio/HotTopicList.vue'),
		meta: {
			title: '热门话题',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/my',
		component: () => import('@/views/My.vue'),
		meta: {
			title: '我的',
			requiresAuth: true,
			showTabBar: true
		}
	},
	{
		path: '/package-detail',
		component: () => import('@/views/service/PackageDetail.vue'),
		meta: {
			title: '套餐详情',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/my/setting',
		component: () => import('@/views/my/Setting.vue'),
		meta: {
			title: '设置',
			requiresAuth: true,
			showTabBar: false
		}
	},
	{
		path: '/my/recharge',
		component: () => import('@/views/my/Recharge.vue'),
		meta: {
			title: '充值',
			requiresAuth: true,
			showTabBar: false
		}
	},
	{
		path: '/my/recharge-history',
		component: () => import('@/views/my/RechargeHistory.vue'),
		meta: {
			title: '充值记录',
			requiresAuth: true,
			showTabBar: false
		}
	},
	{
		path: '/my/personal',
		component: () => import('@/views/my/Personal.vue'),
		meta: {
			title: '个人信息',
			requiresAuth: true,
			showTabBar: false
		}
	},
	{
		path: '/my/edit-mobile',
		component: () => import('@/views/my/EditMobile.vue'),
		meta: {
			title: '修改手机号',
			requiresAuth: true,
			showTabBar: false
		}
	},
	{
		name: 'OrderList',
		path: '/order/list',
		component: () => import('@/views/order/OrderList.vue'),
		meta: {
			title: '订单',
			requiresAuth: true,
			showTabBar: false
		}
	},
	{
		path: '/order/detail',
		component: () => import('@/views/order/OrderDetail.vue'),
		meta: {
			title: '订单详情',
			requiresAuth: true,
			showTabBar: false
		}
	},
	{
		name: 'OrderBooking',
		path: '/order/order-booking',
		component: () => import('@/views/order/OrderBooking.vue'),
		meta: {
			title: '预约下单',
			requiresAuth: true,
			showTabBar: false
		}
	},
	{
		name: 'OrderExtend',
		path: '/order/order-extend',
		component: () => import('@/views/order/OrderExtend.vue'),
		meta: {
			title: '订单加钟',
			requiresAuth: true,
			showTabBar: false
		}
	},
	{
		name: 'AddressList',
		path: '/address/list',
		component: () => import('@/views/address/AddressList.vue'),
		meta: {
			title: '地址列表',
			requiresAuth: true,
			showTabBar: false
		}
	},
	{
		name: 'AddressSave',
		path: '/address/save',
		component: () => import('@/views/address/AddressSave.vue'),
		meta: {
			title: '地址保存',
			requiresAuth: true,
			showTabBar: false
		}
	},
	{
		name: 'Story',
		path: '/core/story',
		component: () => import('@/views/core/Story.vue'),
		meta: {
			title: '我们的故事',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		name: 'Academy',
		path: '/core/academy',
		component: () => import('@/views/core/Academy.vue'),
		meta: {
			title: '香学院',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		name: 'Formula',
		path: '/core/formula',
		component: () => import('@/views/core/Formula.vue'),
		meta: {
			title: '配方',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		name: 'Product',
		path: '/core/product',
		component: () => import('@/views/core/Product.vue'),
		meta: {
			title: '产品',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/login',
		component: () => import('@/views/Login.vue'),
		meta: {
			title: '登录',
			requiresAuth: true,
			showTabBar: false
		}
	},
	{
		path: '/mobile-login',
		component: () => import('@/views/MobileLogin.vue'),
		meta: {
			title: '手机号登录',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/login-callback',
		component: () => import('@/views/callback/LoginCallback.vue'),
		meta: {
			title: '登录中',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/account-error',
		component: () => import('@/views/AccountError.vue'),
		meta: {
			title: '帐号异常',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/select-location',
		name: 'SelectLocation',
		component: () => import('@/views/location/SelectLocation.vue'),
		meta: {
			title: '选择位置',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/my/preference',
		component: () => import('@/views/my/Preference.vue'),
		meta: {
			title: '偏好设置',
			requiresAuth: true,
			showTabBar: false
		}
	},
	{
		path: '/my/favorites',
		component: () => import('@/views/my/Favorites.vue'),
		meta: {
			title: '关注列表',
			requiresAuth: true,
			showTabBar: false
		}
	},
	{
		path: '/my/official-account',
		component: () => import('@/views/my/OfficialAccount.vue'),
		meta: {
			title: '扫码关注',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/corp/index',
		component: () => import('@/views/corp/Index.vue'),
		meta: {
			title: '关于',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/corp/policy',
		component: () => import('@/views/corp/Policy.vue'),
		meta: {
			title: '隐私政策',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/corp/agreement',
		component: () => import('@/views/corp/Agreement.vue'),
		meta: {
			title: '用户协议',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/corp/duty',
		component: () => import('@/views/corp/Duty.vue'),
		meta: {
			title: '责任声明',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/corp/about-us',
		component: () => import('@/views/corp/AboutUs.vue'),
		meta: {
			title: '关于我们',
			requiresAuth: false,
			showTabBar: false
		}
	},
]

const router = createRouter({
	//history: createWebHistory(), // 微信H5建议用hash模式，也不一定。
	history: createWebHashHistory(), // 改为Hash模式，URL会带#
	routes
})

// 全局变量：记录登录后要跳转的目标页
let loginTargetPath = '';

// 动态设置标题
router.beforeEach((to, from, next) => {
	document.title = to.meta.title + '-春信精油' || '春信精油'

	// 1. 跳转到登录页时，记录目标页（redirect参数）
	if (to.path === '/login' && from.path && from.path !== '/login') {
		const redirectPath = from.path + (Object.keys(from.query).length > 0
			? `?${new URLSearchParams(from.query).toString()}`
			: '');
		to.query.redirect = encodeURIComponent(redirectPath);
		// 存储目标页到全局变量
		loginTargetPath = redirectPath;
	}

	// 2. 登录成功后跳转到目标页时，标记该页面“来自登录”
	if (to.path === '/login-callback') {
		localStorage.setItem('fromLogin', true);// 标记：当前页面是登录后跳转而来
		// 清除记录，避免重复标记
		loginTargetPath = '';
	}

	next()
})

export default router